import { ApplicationState } from 'application/redux';
import { close as closeModal, open as openModal } from 'core/modal/redux/actions';
import { executeCommand } from 'core/utils/deviceUtils';
import { connect } from 'react-redux';
import {
  resetActions,
  runCommands,
  toggleAccordion,
  toggleAccordionOptions
} from '../redux/actions';
import ActionsComponent from './actions-component';

const mapStateToProps = (state: ApplicationState) => ({
  settings: state.devices.detail._settings,
  t: state.i18n.t,
  general: state.devices.detail.general,
});

export default connect(mapStateToProps, {
  toggleAccordion,
  toggleAccordionOptions,
  openModal,
  closeModal,
  resetActions,
  runCommands,
  executeCommand,
})(ActionsComponent);
